export const routes = {
  homepage: '/',
  signup: '/signup',
};
